import { formFieldOnScanEdit } from '../enums/formFieldOnScanEdit';
import gridViewFieldsUtils from '../utils/gridViewFieldsUtils';
import dataFieldUtils from '../utils/dataFieldUtils';

class FormFieldOnScanEditUtils {
	getAppliedAndRemovedKeysValuePair(
		inventoryForm,
		selectedRecord,
		record,
		retainedKeys
	) {
		let { appliedKeys, removedKeys } = this.getAppliedAndRemovedKeys(
			inventoryForm,
			selectedRecord,
			record,
			retainedKeys
		);
		let applied = appliedKeys.map((x) =>
			this.getKeyValuePair(x, selectedRecord)
		);
		return { applied, removed: removedKeys };
	}

	getAppliedAndRemovedKeys(
		inventoryForm,
		selectedRecord,
		record,
		retainedKeys
	) {
		let currentRecord = record || {};
		// keys holding a value the user pinned - a pin always wins, so the
		// stored value of the record being edited is never loaded over it
		let pinnedKeys = retainedKeys || [];
		// keys the scanned record is not allowed to write over - they keep the
		// value the form already holds (user input or a retained/pinned value)
		let preservedKeys = [];
		// preserved keys whose stored value the edit-load path puts back into
		// the form, so an existing record still shows its own data - they stay
		// editable and are still sent on save
		let removedKeys = [];
		let preserve = (key, linkFieldKey, restoreStoredValue) => {
			[key, linkFieldKey].forEach((k) => {
				if (!k) return;
				if (!preservedKeys.includes(k)) preservedKeys.push(k);
				if (restoreStoredValue && !removedKeys.includes(k))
					removedKeys.push(k);
			});
		};

		inventoryForm.FormFields.forEach((f) => {
			switch (f.OnScanEdit) {
				case formFieldOnScanEdit.AlwaysOverwriteInput: {
					break;
				}
				case formFieldOnScanEdit.AlwaysOverwriteInputExceptBlanks: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let linkFieldKey = dataFieldUtils.getDataFieldName(
							gvf.LinkField
						);
						if (this.isEmptyValue(selectedRecord[key])) {
							preserve(
								key,
								linkFieldKey,
								!pinnedKeys.includes(key)
							);
						}
					});
					break;
				}
				case formFieldOnScanEdit.NeverOverwriteInput: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let isPinned = pinnedKeys.includes(key);
						// a pinned value keeps the stored value out of the
						// form, so the link id of the record being edited
						// must stay out too - the pinned value is resolved
						// again on save
						preserve(
							key,
							isPinned
								? dataFieldUtils.getDataFieldName(gvf.LinkField)
								: null,
							!isPinned
						);
					});
					break;
				}
				case formFieldOnScanEdit.OnlyOverwriteEmptyInput: {
					f.GridViewFields.forEach((gvf) => {
						let key = gridViewFieldsUtils.getFieldName(gvf);
						let linkFieldKey = dataFieldUtils.getDataFieldName(
							gvf.LinkField
						);
						// the field already has a value - keep it editable and
						// keep it in the save payload, just don't overwrite it
						if (!this.isEmptyValue(currentRecord[key])) {
							preserve(key, linkFieldKey, false);
						}
					});
					break;
				}
			}
		});

		let appliedKeys = Object.keys(selectedRecord).filter(
			(key) => !preservedKeys.includes(key)
		);

		return { appliedKeys, removedKeys };
	}

	isEmptyValue(value) {
		if (value === null || value === undefined || value === '') return true;
		if (Array.isArray(value) && value.length === 0) return true;
		return false;
	}

	getKeyValuePair(key, selectedRecord) {
		return { key: key, value: selectedRecord[key] };
	}
}
const formFieldOnScanEditUtils = new FormFieldOnScanEditUtils();
export default formFieldOnScanEditUtils;
